import { APIService } from "../../../../network/api/APIService";


export const LoginUser = (formData) => {
  return APIService({
      endpoint: "/authentication/login/",
      method: "POST",
      data: formData
  });
};